import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Input, DatePicker, Select, Spin, Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTemplates } from '../../slices/templatesSlice';
import dayjs from 'dayjs';
import { useNotification } from '../../Helper/NotificationProvider';
import store from '../../store';
import { addSchedule, fetchSchedules } from '../../slices/scheduleSlice';
import { fetchCustomers } from '../../slices/customersSlice';
import TemplatePreview from '../TemplatePreview/TemplatePreview';

const { Option } = Select;

const AddScheduleModal = ({ event, currentEventId, setCurrentEventId }) => {


  const dispatch = useDispatch();
  const { openNotification } = useNotification();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const templates = useSelector(state => state.templates.data);
  const templatesStatus = useSelector(state => state.templates.status);
  const [initialValues, setInitialValues] = useState(null);
  const customers = useSelector(state => state.customers.data);
  const user = store.getState().auth.user;
  const selectedCustomer = store.getState().customers.selectedCustomer || user?.tenantId;
  const customer = customers.find(customer => customer.key === selectedCustomer);
  const { RangePicker } = DatePicker;
  const [form] = Form.useForm();
  const [onlySTartTime, setOnlySTartTime] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const handleTemplateChange = (value, option) => {
    form.setFieldsValue({ template: option });
    setSelectedTemplate(option?.label);
  };

  const handleFormSubmit = async (values) => {
   try{
     setOnlySTartTime(false)
     const currentCustomer =  customers?.find(customer => customer.key === selectedCustomer)
     if(!currentCustomer){
       dispatch(fetchCustomers())
       throw new Error('Kunden nicht geladen.');
     }
     const settings = {
       sepiooAccount: currentCustomer.sepiooAccount,
       sepiooApiKey: currentCustomer.sepiooApiKey,
       sepiooLocation: currentCustomer.sepiooLocation
     }

     const scheduleData = {
       event: event.key,
       settings,
       description: values.description,
       startTime: dayjs(values.timeRange[0]).toISOString(),
       endTime: values.timeRange[1] ? dayjs(values.timeRange[1]).toISOString() : null,
       templateId: values.template.value,
       templateName: values.template.label,
     };
     await dispatch(addSchedule(scheduleData))
     dispatch(fetchSchedules())
     openNotification('bottomRight', 'Plan hinzugefügt', "Neuer Plan wurde erfolgreich angelegt.", true);
   } catch (error) {
       console.error('Error adding event:', error);
       openNotification('bottomRight', 'Fehler', "Plan konnte nicht hinzugefügt/angepasst werden. Bitte später erneut versuchen.", false);
   }
   setCurrentEventId(null)
  };

  useEffect(() => {
    setIsModalVisible(event.key === currentEventId)
  }, [currentEventId]);

  useEffect(() => {
    if (templatesStatus === 'idle') {
      dispatch(fetchTemplates());
    }
  }, [templatesStatus, dispatch]);

  const onSwitchChange = (checked, event) => {
    setOnlySTartTime(checked)
    form.setFieldsValue({ timeRange: undefined });
  }

  return (
    <Modal
      title={initialValues?.id ? "Plan bearbeiten" : "Plan hinzufügen"}
      visible={isModalVisible}
      onCancel={() => setCurrentEventId(null)}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={(values) => {
          handleFormSubmit(values);
          form.resetFields();
        }}
        initialValues={initialValues || {}}
      >
        <Form.Item
          label="Beschreibung"
          name="description"
          rules={[{ required: true, message: "Bitte Beschreibung eingeben" }]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item
          label="Template"
          name="template"
          rules={[{ required: true, message: "Bitte Template auswählen" }]}
        >
          <Select
            showSearch
            placeholder="Template auswählen"
            value={form.getFieldValue("template")?.value || undefined}
            onChange={(value, option) => handleTemplateChange(value, option)}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={[
              ...new Map(templates?.filter(template => template?.locations?.includes(customer?.sepiooLocation))
                .map((item) => [item.name, item])).values(),
            ].map(item => ({
              value: item.id,
              label: item.name,
            }))}
          />
          
          {(() => {
            const template = templates?.find(template => template?.name === selectedTemplate);

            return <>
              <div
                style={{marginTop: "10px"}}
              >
                <TemplatePreview 
                  templateName={template?.name}
                  sourceCode={template?.sourceCode} 
                />
              </div>
            </>
          })()}
        </Form.Item>

        <Form.Item
          label="Zeitraum"
          name="timeRange"
          rules={[{ required: true, message: "Bitte einen Zeitraum auswählen" }]}
        >
          <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <div style={{display: 'flex', flexDirection: 'row', marginBottom: 10}}>
              <Switch
                style={{marginTop: 2, marginRight: 5, width: '30px'}}
                defaultChecked={false}
                onChange={onSwitchChange}
                size="small"
              />
              <p style={{margin: 0, fontSize: 12}}>(Nur Startzeit)</p>
            </div>
            {onlySTartTime ?
              <DatePicker
                showTime
                format="DD.MM.YYYY HH:mm"
                style={{ width: "50%" }}
                placeholder="Startzeit"
                onChange={(date) => form.setFieldsValue({ timeRange: [date, null] })}
              />
              :
              <RangePicker
                showTime
                format="DD.MM.YYYY HH:mm"
                style={{ width: '100%' }}
                placeholder={["Startzeit", "Endzeit"]}
                onChange={(dates) => form.setFieldsValue({ timeRange: dates })}
              />
            }
          </div>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Bestätigen
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddScheduleModal;
